import RestAPIClient from "services/RestAPIClient";
import { ICategoryRequest, ICategory } from "./typings";

class CategoryService extends RestAPIClient {
  constructor() {
    super("categories");
  }

  getCategories = async (req: ICategoryRequest): Promise<ICategory[]> => {
    const { limit, offset } = req;
    const res = await this.post(
      `?${this.querystring.stringify({ limit, offset })}`,
      req
    );
    return res.data;
  };
}

export default new CategoryService();
